import { render, staticRenderFns } from "./DocumentAdd.vue?vue&type=template&id=b91b0d48&"
import script from "./DocumentAdd.vue?vue&type=script&lang=js&"
export * from "./DocumentAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports